/**
 * Version History translations
 * Version history UI text
 */

import { LANGUAGES } from '../config';

export const versionHistoryTranslations = {
  [LANGUAGES.EN]: {
    title: 'Version History',
    noVersions: 'No versions available',
    currentVersion: 'Current Version',
    current: 'Current',
    viewingVersion: 'Viewing',
    viewDetails: 'View Details',
    viewVersion: 'View Version',
    restoreVersion: 'Create new version from this',
    confirmRestore: 'Create new version from this data?',
    confirmRestoreMessage: 'This will create a new version with the selected data. All existing versions will be preserved.',
    versionRestored: 'New version created successfully',
    restore: 'Create New Version',
    compareWith: 'Compare with',
    changes: 'Changes',
    timestamp: 'Timestamp',
    author: 'Author',
    system: 'System',
    ai: 'AI',
    user: 'User',
    admin: 'Admin',
    manager: 'Manager',
    added: 'Added',
    modified: 'Modified',
    removed: 'Removed',
    noChanges: 'No changes',
    viewFullVersion: 'View Full Version',
    restoreThisVersion: 'Restore This Version',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    unknown: 'Unknown',
    userEdit: 'User Edit',
    adminEdit: 'Admin Edit',
    managerEdit: 'Manager Edit',
    aiAnalysis: 'AI Analysis',
    unknownDate: 'Unknown date',
    noHistoryAvailable: 'No version history available.',
    version: 'Version',
    viewDetailedChanges: 'View detailed changes',
    viewChangeDetails: 'View change details',
    restoredFrom: '(Restored from version {version})',
    addedItems: 'Added Items ({count})',
    modifiedItems: 'Modified Items ({count})',
    removedItems: 'Removed Items ({count})',
    unnamedItem: 'Unnamed Item',
    unnamedCompetency: 'Unnamed Competency',
    unnamedSkill: 'Unnamed Skill',
    unnamedSection: 'Unnamed Section',
    category: 'Category',
    proficiency: 'Proficiency',
    notSpecified: 'Not specified',
    viewThisVersion: 'View This Version',
    cvDescription: 'View how this CV analysis has changed over time.',
    jobDescription: 'View how this job skills analysis has changed over time.',
    companyDescription: 'View how this company research has changed over time.',
    canRestoreNote: 'You can restore a previous version if needed.',
    to: 'to',
    versionInformation: 'Version Information',
    currentVersioningSystem: 'Current Versioning System:',
    cleanVersioningActive: 'Clean versioning system active (no backward compatibility)',
    usersWithVersionedData: 'Users with versioned data: {count}',
    totalVersionedFiles: 'Total versioned files: {count}',
    versionHistoryTitle: 'Version History:',
    checkVersionStatus: 'Check Version Status'
  },
  [LANGUAGES.FR]: {
    title: 'Historique des versions',
    noVersions: 'Aucune version disponible',
    currentVersion: 'Version actuelle',
    current: 'Actuelle',
    viewingVersion: 'En cours de visualisation',
    viewDetails: 'Voir les détails',
    viewVersion: 'Voir la version',
    restoreVersion: 'Créer une nouvelle version à partir de celle-ci',
    confirmRestore: 'Créer une nouvelle version à partir de ces données?',
    confirmRestoreMessage: 'Cela créera une nouvelle version avec les données sélectionnées. Toutes les versions existantes seront préservées.',
    versionRestored: 'Nouvelle version créée avec succès',
    restore: 'Créer une Nouvelle Version',
    compareWith: 'Comparer avec',
    changes: 'Modifications',
    timestamp: 'Horodatage',
    author: 'Auteur',
    system: 'Système',
    ai: 'IA',
    user: 'Utilisateur',
    admin: 'Administrateur',
    manager: 'Gestionnaire',
    added: 'Ajouté',
    modified: 'Modifié',
    removed: 'Supprimé',
    noChanges: 'Aucune modification',
    viewFullVersion: 'Voir la version complète',
    restoreThisVersion: 'Restaurer cette version',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    unknown: 'Inconnu',
    userEdit: 'Édition Utilisateur',
    adminEdit: 'Édition Administrateur',
    managerEdit: 'Édition Gestionnaire',
    aiAnalysis: 'Analyse IA',
    unknownDate: 'Date inconnue',
    cvDescription: 'Voir comment cette analyse de CV a évolué au fil du temps.',
    jobDescription: 'Voir comment cette analyse de compétences professionnelles a évolué au fil du temps.',
    companyDescription: 'Voir comment cette recherche d\'entreprise a évolué au fil du temps.',
    canRestoreNote: 'Vous pouvez restaurer une version précédente si nécessaire.',
    to: 'à',
    noHistoryAvailable: 'Aucun historique de version disponible.',
    version: 'Version',
    viewDetailedChanges: 'Voir les modifications détaillées',
    restoredFrom: '(Restauré de la version {version})',
    addedItems: 'Éléments ajoutés ({count})',
    modifiedItems: 'Éléments modifiés ({count})',
    removedItems: 'Éléments supprimés ({count})',
    unnamedItem: 'Élément sans nom',
    unnamedCompetency: 'Compétence sans nom',
    unnamedSkill: 'Compétence sans nom',
    unnamedSection: 'Section sans nom',
    category: 'Catégorie',
    proficiency: 'Niveau de compétence',
    notSpecified: 'Non spécifié',
    viewThisVersion: 'Voir cette version',
    viewChangeDetails: 'Voir les détails des modifications',
    versionInformation: 'Informations de version',
    currentVersioningSystem: 'Système de versioning actuel:',
    cleanVersioningActive: 'Système de versioning propre actif (aucune compatibilité descendante)',
    usersWithVersionedData: 'Utilisateurs avec des données versionnées: {count}',
    totalVersionedFiles: 'Total des fichiers versionnés: {count}',
    versionHistoryTitle: 'Historique des versions:',
    checkVersionStatus: 'Vérifier le statut de version'
  }
};
